<ul class="navbar-nav ms-auto">
  <li class="nav-item dropdown" ngbDropdown placement="bottom-end">
    <a class="nav-link d-flex align-items-center text-light" id="userDropdown" >
      <i class="bi bi-person-circle me-2 fs-5"></i>
      <span class="">{{ userData?.data?.name }}</span>
    </a>

  </li>
</ul>
